export const url_action = (url) => ({
    type: 'URL',
    payload: { 
      url: url
    }
  });
